/**
 *  Site constant module file
**/

export const MODULE_NAME = 'site'

export const ACTIONS = {
  FETCH_CONFIG: 'fetchConfig',
  FETCH_BACK_LINK: 'fetchBackLink',
  SET_BILLING_NOTIFICATION: 'setNotification'
}

export const GETTERS = {
}

export const MUTATIONS = {
  SET_CONFIG: 'setConfig',
  SET_BACK_LINK: 'setBackLink',
  SAVE_BILLING_NOTIFICATION: 'saveNotification'
}
